import Vue from 'vue'
import { LEARNICS_EXTENSION_IDS } from '@learnics/models/src/ExtensionInstallation/utils/extensionIds.mjs'

// Helper functions.  We support multiple extensions for each distribution type,
// but we only support one deployment type per distribution type at a time.
// If you run multiple deployment types, the first one will be used, with prod
// being preferred over staging.
function getDeploymentType(state, distributionType) {
  const deploymentTypes = ['prod', 'staging'] // These are only actual chrome store deployment types.
  return deploymentTypes.find(
    (deploymentType) =>
      LEARNICS_EXTENSION_IDS[distributionType][deploymentType] &&
      !!state.extensionManifest[
        LEARNICS_EXTENSION_IDS[distributionType][deploymentType]
      ],
  )
}

function getProp(state, distributionType, propName) {
  const upperCasePropName = propName.charAt(0).toUpperCase() + propName.slice(1)
  return state[`extension${upperCasePropName}`][
    LEARNICS_EXTENSION_IDS[distributionType][
      getDeploymentType(state, distributionType)
    ]
  ]
}

export const state = {
  extensionManifest: {},
  extensionSelectedSessionId: {},
  extensionSelectedAssignmentId: {},
  extensionLogging: {},
  extensionInitializingLogger: {},
}

export const getters = {
  extensionSelectedSessionId: (state) => state.extensionSelectedSessionId,
  extensionSelectedAssignmentId: (state) => state.extensionSelectedAssignmentId,
  extensionLogging: (state) => state.extensionLogging,
  extensionInitializingLogger: (state) => state.extensionInitializingLogger,
  extensionManifest: (state) => state.extensionManifest,
  oneClickManifest: (state) => getProp(state, 'oneClick', 'manifest'),
  studentLinkManifest: (state) => getProp(state, 'studentLink', 'manifest'),
  classroomProManifest: (state) => getProp(state, 'classroomPro', 'manifest'),
  studentLinkLogging: (state) => getProp(state, 'studentLink', 'logging'),
  oneClickLogging: (state) => getProp(state, 'oneClick', 'logging'),
  studentLinkSelectedSessionId: (state) =>
    getProp(state, 'studentLink', 'selectedSessionId'),
  oneClickSelectedSessionId: (state) =>
    getProp(state, 'oneClick', 'selectedSessionId'),
  studentLinkSelectedAssignmentId: (state) =>
    getProp(state, 'studentLink', 'selectedAssignmentId'),
  oneClickSelectedAssignmentId: (state) =>
    getProp(state, 'oneClick', 'selectedAssignmentId'),
  studentLinkInitializingLogger: (state) =>
    getProp(state, 'studentLink', 'initializingLogger'),
  oneClickInitializingLogger: (state) =>
    getProp(state, 'oneClick', 'initializingLogger'),
}

export const mutations = {
  setExtensionLogging(state, payload) {
    Vue.set(state.extensionLogging, payload.extensionId, payload.logging)
  },
  setExtensionManifest(state, payload) {
    Vue.set(state.extensionManifest, payload.extensionId, payload.manifest)
  },
  setExtensionSelectedSessionId(state, payload) {
    Vue.set(
      state.extensionSelectedSessionId,
      payload.extensionId,
      payload.selectedSessionId,
    )
  },
  setExtensionSelectedAssignmentId(state, payload) {
    Vue.set(
      state.extensionSelectedAssignmentId,
      payload.extensionId,
      payload.selectedAssignmentId,
    )
  },
  setExtensionInitializingLogger(state, payload) {
    Vue.set(
      state.extensionInitializingLogger,
      payload.extensionId,
      payload.initializingLogger,
    )
  },
}

export const actions = {}
